import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import UploadPage from './pages/UploadPage';
import SchoolDetails from './pages/SchoolDetails';
import SchoolsListPage from './pages/SchoolsListPage';
import AlertsPage from './pages/AlertsPage';
import ContractorsPage from './pages/ContractorsPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import ExecutivePage from './pages/ExecutivePage';
import WorkOrdersPage from './pages/WorkOrdersPage';
import FacilityEngineersPage from './pages/FacilityEngineersPage';
import SupervisorsPage from './pages/SupervisorsPage';
import SiteVisitsPage from './pages/SiteVisitsPage';
import SupplyPage from './pages/SupplyPage';
import SupplyModuleImportPage from './pages/SupplyModuleImportPage';
import SupplyDynamicImportPage from './pages/SupplyDynamicImportPage';
import SupplyExecutiveDashboard from './pages/SupplyExecutiveDashboard';
import SuppliersListPage from './pages/SuppliersListPage';
import SupplierDetailPage from './pages/SupplierDetailPage';
import ItemsListPage from './pages/ItemsListPage';
import MapPage from './pages/MapPage';
import DataQualityCenter from './pages/DataQualityCenter';
import AdministrationsListPage from './pages/AdministrationsListPage';
import AdministrationDetailPage from './pages/AdministrationDetailPage';
import { placeholder, ReadinessPlanPlaceholder } from './components/PlaceholderCatalog';
import { ImportCenter, DepartmentImportPage } from './pages/DepartmentImportPage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* SUPPLY-ONLY MODE (Feb 2026 pivot).
              `/` now shows the Supply Executive Dashboard.
              Non-Supply routes (dashboard, alerts, contractors, work-orders, etc.)
              remain wired below so nothing is lost — they're just not linked from the sidebar. */}
          <Route path="/" element={<SupplyExecutiveDashboard />} />
          <Route path="/dashboard-legacy" element={<Dashboard />} />

          {/* Supply routes */}
          <Route path="/supply" element={<SupplyPage />} />
          <Route path="/supply/imports/:module" element={<SupplyModuleImportPage />} />
          <Route path="/supply/dynamic-import" element={<SupplyDynamicImportPage />} />
          <Route path="/suppliers-list" element={<SuppliersListPage />} />
          <Route path="/suppliers/:name" element={<SupplierDetailPage />} />
          <Route path="/items-list" element={<ItemsListPage />} />

          <Route path="/upload" element={<UploadPage />} />
          <Route path="/schools" element={<SchoolsListPage />} />
          <Route path="/alerts" element={<AlertsPage />} />
          <Route path="/contractors" element={<ContractorsPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/executive" element={<ExecutivePage />} />
          <Route path="/school/:id" element={<SchoolDetails />} />
          <Route path="/work-orders" element={<WorkOrdersPage />} />
          <Route path="/facility-engineers" element={<FacilityEngineersPage />} />
          <Route path="/supervisors" element={<SupervisorsPage />} />
          <Route path="/site-visits" element={<SiteVisitsPage />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/data-quality" element={<DataQualityCenter />} />
          <Route path="/administrations" element={<AdministrationsListPage />} />
          <Route path="/administrations/:name" element={<AdministrationDetailPage />} />

          {/* Readiness Plan — explicitly EMPTY per spec, shows "Coming Soon" */}
          <Route path="/readiness-plan" element={<ReadinessPlanPlaceholder />} />

          {/* Import Center — hub + one page per department (Maintenance / Supply / Construction / Schools / Contracts) */}
          <Route path="/imports"                  element={<ImportCenter />} />
          <Route path="/imports/maintenance"      element={<DepartmentImportPage department="maintenance" />} />
          <Route path="/imports/supply"           element={<DepartmentImportPage department="supply" />} />
          <Route path="/imports/construction"     element={<DepartmentImportPage department="construction" />} />
          <Route path="/imports/schools"          element={<DepartmentImportPage department="schools" />} />

          {/* New navigation placeholders — one route per catalog key */}
          <Route path="/notifications"           element={placeholder('notifications')} />
          <Route path="/emergency-maintenance"   element={placeholder('emergency-maintenance')} />
          <Route path="/incident-categories"     element={placeholder('incident-categories')} />
          <Route path="/suppliers"               element={placeholder('suppliers')} />
          <Route path="/supply-items"            element={placeholder('supply-items')} />
          <Route path="/lpc-statements"          element={placeholder('lpc-statements')} />
          <Route path="/supply-progress"         element={placeholder('supply-progress')} />
          <Route path="/supply-distribution"     element={placeholder('supply-distribution')} />
          <Route path="/supply-returns"          element={placeholder('supply-returns')} />
          <Route path="/construction-projects"      element={placeholder('construction-projects')} />
          <Route path="/construction-engineers"     element={placeholder('construction-engineers')} />
          <Route path="/construction-work-orders"   element={placeholder('construction-work-orders')} />
          <Route path="/construction-visits"        element={placeholder('construction-visits')} />
          <Route path="/school-info"             element={placeholder('school-info')} />
          <Route path="/school-equipment"        element={placeholder('school-equipment')} />
          <Route path="/school-status"           element={placeholder('school-status')} />
          <Route path="/contract-renewals"       element={placeholder('contract-renewals')} />
          <Route path="/contract-warranties"     element={placeholder('contract-warranties')} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
